import logoUrl from '@/assets/ardinotech-logo.png';

let cached: string | null = null;

/** Returns the Ardinotech logo as a base64 data URL, suitable for jsPDF addImage(). */
export async function getLogoDataUrl(): Promise<string> {
  if (cached) return cached;
  const resp = await fetch(logoUrl);
  const blob = await resp.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => { cached = reader.result as string; resolve(cached); };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
